<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAnalyticsChart_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M7.158 2a1 1 0 0 0-1 1v7.21a1 1 0 0 0 1 1h1.316a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM3.474 4.947a1 1 0 0 0-1 1v4.264a1 1 0 0 0 1 1h.947a1 1 0 0 0 1-1V5.946a1 1 0 0 0-1-1zm6.736 1a1 1 0 0 1 1-1h.948a1 1 0 0 1 1 1v4.264a1 1 0 0 1-1 1h-.947a1 1 0 0 1-1-1zm-8.473 6.369a.737.737 0 0 0 0 1.473h12.526a.737.737 0 0 0 0-1.473z"
        clip-rule="evenodd"
    />
</svg>
